import { useEffect, useState } from "react";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import Button from "../../FormComponents/Button";
import Input from "../../FormComponents/Input";
import SingleSelectBox from "../../FormComponents/SingleSelectBox";
import TableTreeModal from "../TableTreeModal";
import ValueAccordingOperator from "./ValueAccordingOperator";
import MaterialIcon from "../MaterialIcon";
import { hasOwn } from "../../../commonFunctions/arrayFunc";
import { toastError } from "../../../utils/toastUtils";

const PreFilterTable = ({
  preFilters,
  setPreFilters,
  tableId,
  folderId = [],
  operatorList,
  tableObj,
  filterValues,
  valueOptions,
  tableType = "statemachine"
}) => {
  const [isPreFilterModalOpen, setIsPreFilterModalOpen] = useState(false);
  const preFilterCallbackFunction = (data) => {
    const newArray = [...preFilters];
    newArray.push({
      ...data,
      alias: ""
    });
    setPreFilters(newArray);
    setIsPreFilterModalOpen(false);
  };

  const modifyPreFilters = (action, index) => {
    if (action === "remove") {
      const selectedCopy = [...preFilters];
      selectedCopy.splice(index, 1);
      setPreFilters(selectedCopy);
    }
  };

  const updatePrefilter = (index, type, value) => {
    let copyPrefilter = JSON.parse(JSON.stringify(preFilters)); //operator
    copyPrefilter[index][type] = type === "number_value" ? parseInt(value) : value;
    if (type === "operator") {
      const newObj = removeObjectKeys(copyPrefilter[index]);
      copyPrefilter[index] = newObj;
    }
    setPreFilters(copyPrefilter);
  };

  const removeObjectKeys = (obj) => {
    const newObj = JSON.parse(JSON.stringify(obj));
    const keysToDelete = [
      "text_value",
      "rdbms_value",
      "number_value",
      "number_range",
      "human_date",
      "custom_date_range",
      "text_array"
    ];
    keysToDelete.forEach((key) => {
      if (hasOwn(newObj, key)) {
        delete newObj[key];
      }
    });

    return newObj;
  };

  // const getAppUserData = async () => {
  //   try {
  //     const { data } = await axiosInstance.get(`/userConfig`);
  //     setAllAppuserData(data.fields || []);
  //   } catch (error) {
  //     handleError(error);
  //   }
  // };

  // useEffect(() => {
  //   getAppUserData();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // if (preFilters.length === 0) return;
  // if (preFilters.length === 0) return;
  if (!tableObj && !filterValues) return;
  return (
    <>
      {preFilters.length !== 0 && (
        <div className="prefilter_box">
          <div className="prefilter_header d_flex gap_3 mb_0">
            <div style={{ width: "86px" }}>Alias</div>
            <div style={{ width: "300px" }}>Operator</div>
            <div style={{ width: "300px" }}>Value</div>
          </div>
          {preFilters?.map((field, index) => (
            <div className="preFilter_form p_3" key={field.id}>
              <div className="prefilter_name">
                <span>
                  {field?.prefix ? field.prefix + " | " : ""}
                  {field.display || field.name}
                </span>
                <MaterialIcon
                  name="delete"
                  className="builder_action_btn delete"
                  onClick={() => modifyPreFilters("remove", index)}
                />
              </div>

              <div key={field.id}>
                <SinglePrefilterRenderer
                  index={index}
                  field={field}
                  updatePrefilter={updatePrefilter}
                  preFilters={preFilters}
                  setPreFilters={setPreFilters}
                  tableId={tableId}
                  operatorList={operatorList}
                  tableObj={tableObj}
                  filterValues={valueOptions || filterValues}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {tableId &&
        (tableType === "statemachine" ||
          tableType === "rdbms" ||
          tableType === "entity" ||
          tableType === "appuser") && (
          <div className="d_flex justify_end mt_3">
            <Button variant="secondary" size="small" onClick={() => setIsPreFilterModalOpen(true)}>
              <MaterialIcon name="add" />
            </Button>
          </div>
        )}
      {filterValues && tableType === "http-template" && (
        <div className="d_flex justify_end mt_3 m" style={{ width: "200px" }}>
          <SingleSelectBox
            options={filterValues}
            onChange={(obj) => preFilterCallbackFunction(obj)}
            label="Add Pre-Filter"
            valueKey="id"
            labelKey={["display"]}
            selectedData=""
          />
        </div>
      )}
      <BuilderModal
        isOpen={isPreFilterModalOpen}
        onClose={() => setIsPreFilterModalOpen(false)}
        modalName={"Add Pre-Filter"}
      >
        <TableTreeModal
          callbackFunction={preFilterCallbackFunction}
          tableId={tableId}
          tableType={tableType}
          folderId={folderId}
        />
      </BuilderModal>
    </>
  );
};

const SinglePrefilterRenderer = ({
  index,
  field,
  updatePrefilter,
  preFilters,
  setPreFilters,
  filterValues,
  tableId,
  operatorList,
  tableObj
}) => {
  const [operatorListForType, setOperatorListForType] = useState([]);

  // const [selectedOperator, setSelectedOperator] = useState("");
  const getOperatorList = () => {
    const fieldType = (tableObj && tableObj[field.id]?.field_type) || field.field_type || field.type;
    const dataType = (tableObj && tableObj[field.id]?.data_type) || field.data_type;
    let finalType = dataType;
    if (!dataType || (dataType && dataType === "unknown")) {
      finalType = fieldType;
    }
    const operatorArray = operatorList.filter((op) => op.fields.includes(finalType));
    setOperatorListForType(operatorArray);
  };
  const updateAlias = (index, type, value) => {
    let copyPrefilter = JSON.parse(JSON.stringify(preFilters));
    // Ensure only one uppercase alphabet is allowed
    const updatedValue = value
      .toUpperCase()
      .replace(/[^A-Z]/g, "")
      .slice(0, 1);

    const isAlreadyPresent = copyPrefilter.some((filter) => filter[type] === updatedValue);

    if (isAlreadyPresent) {
      if (value.length === 1) {
        toastError("Alias already present!");
        return;
      }
    } else {
      copyPrefilter[index][type] = updatedValue;
      setPreFilters(copyPrefilter);
    }
  };

  useEffect(() => {
    getOperatorList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="prefilter_form_items">
      <Input
        type="text"
        placeholder="-"
        containerStyle={{ width: "46px" }}
        value={field?.alias}
        onChange={(e) => updateAlias(index, "alias", e.target.value)}
        inputBoxStyle={{ textAlign: "center" }}
      />

      <SingleSelectBox
        selectedData={field.operator ? field.operator : ""}
        options={operatorListForType}
        valueKey="operator"
        labelKey={["operator_name"]}
        onChange={(obj) => updatePrefilter(index, "operator", obj.operator)}
        placeholder="Select operator"
        containerStyle={{ width: "230px" }}
      />
      <div style={{ width: "150px" }}>
        {field.operator && (
          <ValueAccordingOperator
            value={operatorListForType.find((op) => op.operator === field.operator)?.value}
            updatePrefilter={(valueType, data) => updatePrefilter(index, valueType, data)}
            field={field}
            tableId={tableId}
            tableObj={tableObj}
            filterValues={filterValues}
          />
        )}
      </div>
    </div>
  );
};

export default PreFilterTable;
